import React from 'react'

function TopicBox({title, color, onClick}) {
    const boxStyle = {
        backgroundColor: color,
        padding: "8px 16px",
        borderRadius: "20px",
        cursor: "pointer",
        textAlign: "center",
        fontSize: "13px",
        fontWeight: "600",
        display: "inline-block",
        transition: "all 0.3s ease",
        border: "1px solid transparent",
        boxShadow: "var(--shadow-sm)"
      };
    
  return (
    <div 
      style={boxStyle}
      onClick={onClick}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-3px)';
        e.currentTarget.style.boxShadow = 'var(--shadow-md)';
        e.currentTarget.style.borderColor = 'var(--primary-color)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = 'var(--shadow-sm)';
        e.currentTarget.style.borderColor = 'transparent';
      }}
    >
        <strong>{title}</strong>
      </div>
  );
}

export default TopicBox